const index = () => import(/* webpackChunkName: 'homeIndex' */ '@views/home/index/index')
const MqlMiddlePage = () =>
  import(/* webpackChunkName: 'memberList' */ '@components/core/MqlLayout/MqlMiddlePage/index')

// 订单列表
// const listDetail = () =>
//   import(/* webpackChunkName: 'listDetail' */ '@views/home/order/orderList/listDetail')

const routes = [
  {
    path: '/order',
    component: index,
    name: 'order',
    redirect: { name: 'homeOrderListInfo' },
    hidden: true,
    meta: {
      keepAlive: true,
      title: '订单管理',
      first: true,
      resourceCode: 'ORDER_MANAGE',
      icon: 'order_manage',
      No: 1
    },
    children: [
      {
        path: 'normal',
        name: 'homeOrderList',
        component: MqlMiddlePage,
        redirect: { name: 'homeOrderListInfo' },
        meta: {
          keepAlive: true,
          title: '订单列表',
          second: false,
          resourceCode: 'ORDER_MANAGE01',
          No: 0
        },
        children: [
          {
            path: 'list',
            component: () => import('@views/home/order/orderList'),
            name: 'homeOrderListInfo',
            meta: {
              title: '订单列表',
              keepAlive: true,
              resourceCode: ''
            }
          },
          {
            path: 'detail',
            component: () => import('@views/home/order/orderList/listDetail'),
            name: 'homeOrderListDetail',
            meta: { title: '订单详情', keepAlive: true, resourceCode: '' }
          },
          {
            path: 'detail-mid',
            component: MqlMiddlePage,
            redirect: { name: 'homeOrderListDetail' },
            meta: { title: '订单详情', keepAlive: true, resourceCode: '' },
            children: [
              {
                path: 'performance',
                component: () => import('@views/home/order/orderList/listPerformance'),
                name: 'orderListPerformance',
                meta: { title: '查看业绩', keepAlive: true, resourceCode: '' }
              }
            ]
          }
        ]
      }
      // {
      //     path: 'refund',
      //     name: 'OrderRefundList',
      //     component: MqlMiddlePage,
      //     redirect: { name: 'homeOrderRefund' },
      //     meta: { keepAlive: true, title: '退款列表', second: false, resourceCode: 'ORDER_MANAGE02', No: 1 },
      //     children: [
      //         {
      //             path: 'list',
      //             component: () => import('@views/home/order/orderRefund/index'),
      //             name: 'homeOrderRefund',
      //             meta: { title: '退款列表', keepAlive: true, resourceCode: '' }
      //         },
      //         {
      //             path: 'detail',
      //             component: () => import('@views/home/order/orderRefund/refundDetail'),
      //             name: 'homeOrderRefundDetail',
      //             meta: { title: '退款详情', keepAlive: true }
      //         }
      //     ]
      // }
    ]
  }
]

export default {
  routes
}



// WEBPACK FOOTER //
// ./src/router/home/order.js